<template>
  <div
    :class="[
      {[$style.registration]: redirectLocation !== signup},
      {[$style.adminBackground]: redirectLocation === signup}]"
  >
    <Head />
    <AdminGoogleRegistrationSignup
      v-if="redirectLocation === signup"
      :redirectLocation="redirectLocation"
    />
    <AdminGoogleRegistrationLinksContainer
      v-else
      :clientType="admin"
    />
  </div>
</template>

<script>
import { LocalStorageConsts, RouteGenerator, SignupConsts } from 'client/util/Constants';
import AdminGoogleRegistrationLinksContainer from
  'client/signup/AdminGoogleRegistration/AdminGoogleRegistrationLinksContainer.vue';
import AdminGoogleRegistrationSignup from
  'client/signup/AdminGoogleRegistration/AdminGoogleRegistrationSignup.vue';
import Head from 'client/signup/components/Head.vue';

const { admin } = SignupConsts.clientType;
const { login, signup } = RouteGenerator;
const { googleOrigin } = LocalStorageConsts;

export default {
  name: 'AdminGoogleRegistration',

  components: {
    AdminGoogleRegistrationLinksContainer,
    AdminGoogleRegistrationSignup,
    Head,
  },

  localStorage,

  data() {
    return {
      admin,
      login,
      redirectLocation: signup,
      signup,
    };
  },

  created() {
    if (this.$options.localStorage && this.$options.localStorage.getItem(googleOrigin) === 'true') {
      this.redirectLocation = login;
    }
  },
};
</script>

<style module>
@value (max-width-medium) from '~css/breakpoints.css';

.registration {
  background-color: var(--jcTertiary);
  min-height: 100%;
}

.adminBackground {
  background-image: var(--static-admin-portal-bg-img);
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  min-height: 100%;
  padding: var(--jc-spacer-medium);
}

.adminBackground::after {
  background: rgba(0, 0, 0, 0.2);
  bottom: 0;
  content: '';
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

@media (max-width: max-width-medium) {
  .adminBackground {
    padding: 0;
  }
}
</style>
